<template>
  <div class="card mb-25 border-0 rounded-0 mb-20">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
      >
        <div class="title">
          <h5 class="card-title fw-black mb-0">Statistique Colis (%)</h5>
        </div>
        <div
          class="card-select mt-10 mt-sm-0 d-inline-block d-sm-flex align-items-center ps-10 pe-10 pt-5 pb-5"
        >
          <span class="fw-medium text-muted me-8">Filtrer</span>
          <button
            class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#filterLeadModal"
          >
            <i class="flaticon-dots"></i>
          </button>
        </div>
      </div>
      <div class="col-md-8">
        <div>
          <div class="chart">
            <apexchart
              type="pie"
              height="325"
              :options="customersPie.chartOptions"
              :series="customersPie.series"
            />
          </div>
          <div class="pt-3">
            <div class="d-flex flex-wrap gap-1">
              <span
                v-for="(data, index) in chartData"
                :key="index"
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{ '--dynamic-bg': data.color }"
              >
                {{ data.name }} - {{ data.total }}
                 <!-- ({{ data.num }} %) -->
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Filtrer</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <form class="row">
            <!-- Magasin -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Magasin:</label>
                <label class="form-label">Date de :</label>
                <input type="date" class="form-control" v-model="searchSDate" />
              </div>
            </div>

            <!-- Zone -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label class="form-label">Date Fin :</label>
                <input type="date" class="form-control" v-model="searchEDate" />
              </div>
            </div>

            <!-- Ville -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label class="form-label">Type Colis:</label>
                <select class="form-select" v-model="type">
                  <option value="" selected>Tous</option>
                  <option value="SIMPLE">Colis Simples</option>
                  <option value="STOCK">Colis Stock</option>
                  <option value="SUPPLIER">Colis DropShippers</option>
                  <option value="SIMPLE_STOCK">Colis Produits</option>
                </select>
              </div>
            </div>

            <!-- Livreur -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label class="form-label">Magasin:</label>
                <v-select
                  label="name"
                  :options="ClientList"
                  v-model="customer"
                  placeholder="Chercher un client"
                />
              </div>
            </div>

            <!-- Etat -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label class="form-label">Zone:</label>
                <v-select
                  label="name"
                  :options="ZonesList"
                  v-model="zone"
                  placeholder="Chercher une zone"
                />
              </div>
            </div>

            <!-- Status -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label class="form-label">Agence:</label>
                <v-select
                  label="name"
                  :options="AgencyList"
                  v-model="agency_receiving"
                  placeholder="Chercher une agence"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group mb-3">
                <label class="form-label">Ville:</label>
                <v-select
                  label="name"
                  :options="CitiesList"
                  v-model="city"
                  placeholder="Chercher une ville"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label class="form-label">Livreur:</label>
                <v-select
                  label="name"
                  :options="LivreurList"
                  v-model="livreur"
                  placeholder="Chercher un livreur"
                />
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <!-- <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button> -->
          <button type="button" @click="FilterData" class="btn btn-primary">
            Annuler
          </button>
          <button type="button" @click="ResetAll" class="btn btn-warning">
            Appliquer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import api from "@/utils/axios";
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  setup() {
    const chartData = ref<any>({});

    const searchSDate = ref("");
    const searchEDate = ref("");
    const exist = ref(false);
    const city = ref({ id: 0, name: "" });
    const livreur = ref({ id: 0, name: "" });
    const customer = ref({ id: 0, name: "" });
    const type = ref("");
    const zone = ref({ id: "", name: "" });
    const agency_receiving = ref({ id: 0, name: "" });
    const ClientList = ref<any[]>([]);
    const LivreurList = ref<any[]>([]);
    const CitiesList = ref<any[]>([]);
    const ZonesList = ref<any[]>([]);
    const AgencyList = ref<any[]>([]);
    const show = ref(false);

    const customersPie = ref({
      series: [],
      chartOptions: {
        chart: {
          toolbar: {
            show: false,
          },
          animations: {
            enabled: true,
          },
        },
        labels: [
          "Nouveaux Coliss",
          "Attente De Ramassage",
          "Ramassés",
          "Expédiés",
          "Reçus",
          "Mise en distribution",
          "En cours",
          "Retournés",
          "Livrés",
        ],
        dataLabels: {
          enabled: true,
        },
        legend: { show: false },
        stroke: {
          width: 4,
        },
        colors: ["#084C9D"],
      },
      noData: {
        text: "There's no data",
        align: "center",
        verticalAlign: "middle",
        offsetX: 0,
        offsetY: 0,
      },
    });

    const isLoader = ref(false);

    async function getData() {
      isLoader.value = true;
      try {
        const res = await api.get(
          `/api/auth/ParcelsData?searchSDate=${searchSDate.value}&searchEDate=${
            searchEDate.value
          }&city_id=${city.value?.id ?? ""}&customer=${
            customer.value?.id ?? ""
          }&types=${type.value ?? ""}&zone=${
            zone.value?.id ?? ""
          }&agency_receiving=${agency_receiving.value?.id ?? ""}&livreur=${
            livreur.value?.id ?? ""
          }`
        );
        chartData.value = res.data.list;
        customersPie.value.series = res.data.series;
        customersPie.value.chartOptions = {
          ...customersPie.value.chartOptions,
          colors: res.data.colors,
          labels: res.data.lables,
        };
      } catch (error) {
        // handle error (e.g. show notification)
      } finally {
        isLoader.value = false;
      }
    }

    function isAllZero(arr: number[]): boolean {
      return arr.every((item) => item === 0);
    }

    // Filter data and show sidebar
    function FilterData() {
      getData();
      // If you use a sidebar component, trigger its hide method here
      // Example: sidebar2.value?.hide();
      show.value = true;
    }

    // Reset all filters and reload data
    function ResetAll() {
      searchSDate.value = "";
      searchEDate.value = "";
      type.value = "";
      city.value = { id: 0, name: "" };
      customer.value = { id: 0, name: "" };
      agency_receiving.value = { id: 0, name: "" };
      livreur.value = { id: 0, name: "" };
      zone.value = { id: "", name: "" };
      getData();
      // Example: sidebar2.value?.hide();
    }

    // Download Excel file
    async function GetExcel() {
      try {
        const res = await api.get(
          `/api/auth/ExcelTopData?type=Parcels&searchSDate=${searchSDate.value}&searchEDate=${searchEDate.value}&city_id=${city.value.id}&customer=${customer.value.id}&types=${type.value}&zone=${zone.value.id}&agency_receiving=${agency_receiving.value.id}&livreur=${livreur.value.id}`,
          { responseType: "arraybuffer" }
        );
        const fileURL = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.download = "StatistiquesColis.xlsx";
        fileLink.click();
      } catch (error) {
        // handle error (e.g. show notification)
      }
    }

    // Fetch agency list by zone
    async function FetchAgencyList() {
      try {
        const res = await api.get(`/api/auth/AgenceisZone/${zone.value.id}`);
        AgencyList.value = res.data;
      } catch (error) {
        // handle error
      }
    }

    // Fetch cities list by agency
    async function FetchCitiesList() {
      try {
        const res = await api.get(
          `/api/auth/CitiesAgency/${agency_receiving.value.id}`
        );
        CitiesList.value = res.data;
      } catch (error) {
        // handle error
      }
    }

    // Search clients for dropdown/autocomplete
    async function onSearchClients(
      search: string,
      loading: (state: boolean) => void
    ) {
      if (search.length && ClientList.value.length === 0) {
        loading(true);
        try {
          const response = await api.get(`/api/auth/ListCustomer`);
          ClientList.value = response.data;
        } catch (error) {
          // handle error
        } finally {
          loading(false);
        }
      }
    }

    // Search zones for dropdown/autocomplete
    async function onSearchZones(
      search: string,
      loading: (state: boolean) => void
    ) {
      if (search.length && ZonesList.value.length === 0) {
        loading(true);
        try {
          const response = await api.get(`/api/auth/ListZone`);
          ZonesList.value = response.data;
        } catch (error) {
          // handle error
        } finally {
          loading(false);
        }
      }
    }

    // Search drivers for dropdown/autocomplete
    async function onSearchDrivers(
      search: string,
      loading: (state: boolean) => void
    ) {
      if (search.length && LivreurList.value.length === 0) {
        loading(true);
        try {
          const response = await api.get(`/api/auth/LivsList`);
          LivreurList.value = response.data;
        } catch (error) {
          // handle error
        } finally {
          loading(false);
        }
      }
    }

    onMounted(async () => {
      getData();
    });
    return {
      customersPie,
      chartData,
      getData,
      isAllZero,
      searchSDate,
      searchEDate,
      exist,
      city,
      livreur,
      customer,
      type,
      zone,
      agency_receiving,
      ClientList,
      LivreurList,
      CitiesList,
      ZonesList,
      AgencyList,
      show,
      FilterData,
      ResetAll,
    };
  },
});
</script>
